<template>
  <div class="view">
    <header class="m-header flexsb">
      <div class="left flexa">
        <span>手機：</span>
        <span style="margin-right: 8px">{{ getFakeMobile }}</span>
        <span>申請賬號 (合計：</span>
        <span class="amount">{{ amount }}</span>
        <span>{{ currency }})</span>
      </div>
      <div class="right flexa">
        <span>需支付：</span>
        <span class="amount">{{ amount }}</span>
        <span>{{ currency }}(含手續費)</span>
      </div>
    </header>
    <el-steps :active="steps" align-center>
      <el-step title="關聯賬戶"></el-step>
      <el-step title="確認支付"></el-step>
    </el-steps>
    <div class="container">
      <div class="top">
        <el-form label-width="200px">
          <el-form-item label="付款方式：">
            <div class="flexa">
              <div class="img-box">
                <img :src="bankImg" height="40" alt="" />
                <span
                  style="font-weight: bold"
                  v-if="$route.name === 'fastPay'"
                  >{{ getFakeCardNo }}</span
                >
              </div>
              <span class="text">儲蓄卡</span>
              <img src="@/assets/images/quick_icon.gif" alt="" />
            </div>
            <div>
              <img src="@/assets/images/chooseBank.gif" alt="" />
              <span class="linkH" @click="isBankListShow = true"
                >查看支持銀行</span
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom">
        <router-view
          @getBank="getBank"
          @getBankInfo="getBankInfo"
        ></router-view>
        <!-- <register @changeSteps="changeSteps" @getBank="getBank" v-if="steps === 1"></register>
        <pay v-if="steps === 2"></pay> -->
      </div>
    </div>
    <!-- <div class="footer">
      <header>支付常見問題</header>
      <div>
        <div class="q">1.如何使用快捷支付进行付款</div>
        <div class="a">
          首次選擇快捷支付時，需要填寫您辦理銀行卡的身份信息和預留手機號碼，信息通過驗證后，通過您接收到的短信驗證碼進行開通和支付。
        </div>
        <div class="q">2.快捷支付驗證碼短信的簽名怎麽不是全球付</div>
        <div class="a">
          驗證碼短信由合作渠道商戶發送，不會存在任何風險問題，請您放心
        </div>
      </div>
    </div> -->
    <el-dialog title="支持的銀行" :visible.sync="isBankListShow" width="1100px">
      <div class="bank-list-card">
        <div
          v-for="(item, index) of imageList"
          :key="index"
          class="item"
          @click="selectCard(index)"
        >
          <img :src="item.imgUrl" alt="" />
          <!-- <span>5387 **** **** 7890</span> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isBankListShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fakeByStar60 } from "@/utils/fun";
export default {
  data() {
    return {
      cardNo: "",
      bankImg: require("@/assets/images/bank/logo/104.png"),
      // 判斷當前步驟為第一步還是第二部
      steps: 1,
      bankIndex: 0,
      isBankListShow: false,
      amount: sessionStorage.getItem("amount"),
      currency: sessionStorage.getItem("currency"),
      imageList: [
        {
          id: "ABC",
          imgUrl: require(`@/assets/images/bank/logo/103.png`)
        },
        { id: "BOC", imgUrl: require("@/assets/images/bank/logo/104.png") },
        { id: "CCB", imgUrl: require("@/assets/images/bank/logo/105.png") },
        { id: "CEB", imgUrl: require("@/assets/images/bank/logo/303.png") },
        { id: "CIB", imgUrl: require("@/assets/images/bank/logo/309.png") },
        { id: "CITIC", imgUrl: require("@/assets/images/bank/logo/302.png") },
        { id: "CMB", imgUrl: require("@/assets/images/bank/logo/308.png") },
        { id: "CMBC", imgUrl: require("@/assets/images/bank/logo/305.png") },
        { id: "COMM", imgUrl: require("@/assets/images/bank/logo/301.png") },
        { id: "GDB", imgUrl: require("@/assets/images/bank/logo/306.png") },
        { id: "HXB", imgUrl: require("@/assets/images/bank/logo/304.png") },
        { id: "ICBC", imgUrl: require("@/assets/images/bank/logo/102.png") },
        { id: "PSBC", imgUrl: require("@/assets/images/bank/logo/403.png") },
        { id: "SPAB", imgUrl: require("@/assets/images/bank/logo/307.png") },
        { id: "SPDB", imgUrl: require("@/assets/images/bank/logo/310.png") },
        {
          id: "SHB",
          imgUrl: require("@/assets/images/bank/logo/SHB.png")
        },
        {
          id: "QDCCB",
          imgUrl: require("@/assets/images/bank/logo/QDCCB.png")
        }
      ]
    };
  },
  computed: {
    getFakeMobile() {
      const mobile = sessionStorage.getItem("mobile");
      return mobile ? fakeByStar60(mobile) : "";
    },
    getFakeCardNo() {
      return this.cardNo ? this.cardNo.slice(this.cardNo.length - 6) : "";
    }
  },
  mounted() {
    this.cardNo
      ? ""
      : (this.cardNo = sessionStorage.getItem("bank_acc_no_show") || "");
  },
  methods: {
    getBankInfo(bankInfo) {
      this.imageList.forEach((e2) => {
        if (bankInfo.iss_ins_code === e2.id) {
          this.bankImg = e2.imgUrl;
          this.cardNo = bankInfo.bank_acc_no_show;
        }
      });
      // console.log(
      //   this.cardNo,
      //   this.cardNo.slice(this.cardNo.length - 6),
      //   "cardNo"
      // );
    },
    getBank(obj) {
      this.bankImg = this.imageList.filter(
        (e) => e.id === obj.iss_ins_code
      )[0].imgUrl;
      sessionStorage.setItem("bank_iss_ins_code", obj.iss_ins_code);
      sessionStorage.setItem("bank_acc_no_show", obj.card_no);
    },
    changeSteps(val) {
      this.steps = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  width: 960px;
  margin: 0 auto;
  padding-top: 24px;
  font-family: Arial, "宋体", Verdana, Helvetica, sans-serif;
  .m-header {
    padding: 10px;
    border: 1px dashed #fa800a;
    font-size: 14px;
    color: #666;
    .amount {
      margin-right: 4px;
      font-weight: bold;
      color: #fa800a;
    }
  }
  .el-steps {
    margin: 28px 0;
  }
  .bank-list-card {
    display: flex;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      border: 1px solid #e4e4e4;
      color: #333;
      font-weight: bold;
      line-height: 46px;
      border-radius: 4px;
      width: 150px;
      padding-left: 10px;
      margin-right: 24px;
      margin-bottom: 12px;
    }
    /* .item:hover {
      cursor: pointer;
    } */
    .active {
      border: 1px solid #1187f5;
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    box-shadow: #ccc 0px 0px 20px;
    border-radius: 4px;
    padding: 40px;
    margin-bottom: 40px;
    .img-box {
      display: flex;
      /* justify-content: center; */
      align-items: center;
      width: 180px;
      height: 50px;
      border: 1px solid #e4e4e4;
      border-radius: 4px;
      box-sizing: border-box;
    }
    .text {
      font-size: 12px;
      margin: 0 24px 0 12px;
    }
    .linkH {
      font-size: 12px;
      color: #2272c8;
      cursor: pointer;
      margin-left: 4px;
    }
    .linkH:hover {
      text-decoration: underline;
    }
    .top {
      border-bottom: 1px solid #e4e4e4;
    }
    .bottom {
      padding-top: 24px;
    }
  }
  .footer {
    padding: 50px 32px;
    header {
      font-size: 16px;
      color: #666;
      font-weight: 700;
    }
    .q {
      color: #666;
      font-weight: normal;
      padding-top: 12px;
      float: left;
      width: 100%;
    }
    .a {
      color: #999;
    }
  }
}
</style>
